import type { Milestone, ProgressionState, ServiceType } from '../../types/core';
import { servicesForMilestone } from '../../world/createInitialState';

const milestones: readonly { readonly name: Milestone; readonly population: number }[] = [
  { name: 'Hamlet', population: 0 },
  { name: 'Village', population: 25 },
  { name: 'Town', population: 75 },
  { name: 'Large Town', population: 180 },
  { name: 'City', population: 420 },
  { name: 'Metropolis', population: 900 }
];

export function updateProgression(population: number): ProgressionState {
  const current = [...milestones].reverse().find((milestone) => population >= milestone.population) ?? milestones[0];
  const currentIndex = milestones.findIndex((milestone) => milestone.name === current.name);
  const next = milestones[currentIndex + 1];

  return {
    milestone: current.name,
    unlockedServices: servicesForMilestone(current.name),
    nextMilestonePopulation: next?.population ?? current.population
  };
}

export function serviceLabel(service: ServiceType): string {
  const labels: Record<ServiceType, string> = {
    school: 'Schools',
    police: 'Police',
    fire: 'Fire',
    hospital: 'Hospitals',
    bus: 'Buses',
    train: 'Trains',
    airport: 'Airport',
    utilities: 'Utilities',
    landmarks: 'Landmarks',
    entertainment: 'Entertainment'
  };

  return labels[service];
}
